import { render } from "./AdminsOnlyToggle.vue?vue&type=template&id=295847d0&scoped=true"
import script from "./AdminsOnlyToggle.vue?vue&type=script&lang=js"
export * from "./AdminsOnlyToggle.vue?vue&type=script&lang=js"

import "./AdminsOnlyToggle.vue?vue&type=style&index=0&id=295847d0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-295847d0"]])

export default __exports__